var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"po fish2-con",style:(_vm.getStyles)},_vm._l((9),function(idx){return _c('img',{key:'fish2_'+idx,staticClass:"po fish2_item",class:'fish2_'+idx,style:(_vm.getLuoItemStyle(idx)),attrs:{"src":_vm.getLuoItem(idx)}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }